

















































import { Component, Mixins, Watch } from 'vue-property-decorator';
import Modal from './companies.modal.vue';
import TableMixin from '@/mixins/table.mixin';

@Component({
  components: { Modal },
})
export default class CompaniesShell extends Mixins(TableMixin) {
  columns = [
    {
      label: 'GENERAL.STATUS',
      name: 'isActive',
      sortable: true,
      align: 'center',
    },
    { label: 'GENERAL.NAME', name: 'name', sortable: true },
    { label: 'GENERAL.TITLE', name: 'title', sortable: true },
    {
      label: 'GENERAL.PARENT_COMPANY',
      name: 'parent',
      sortable: true,
      format: (v: { name: string }) => v?.name,
    },
    {
      label: 'GENERAL.PHONE_NUMBER',
      name: 'phoneNumber',
      sortable: true,
    },
    { label: 'GENERAL.CONTACT_PERSON', name: 'contactName', sortable: true },
    { label: 'GENERAL.EMAIL', name: 'email', sortable: true },
    { label: 'GENERAL.ACTIONS', name: 'actions', align: 'center' },
  ];

  @Watch('modal.open')
  onClose(value: boolean) {
    if (!value) this.onUpdateData();
  }
}
